import React, { useMemo } from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../../../../../../components/Spinner';
import { CypressIds } from '../../../../../../../../../../constants/cypressIds';
import { useArchivedRecordPolicies } from '../../../../../../../../../../services/record-service';
import ArchivedModal from '../../../../../../../modals/ArchivedModal';

import { COLUMNS } from './columns';

const ArchivedPoliciesModal = ({ recordId, insuredId, jobId }) => {
  const { data: archivedPolicies, isLoading } = useArchivedRecordPolicies(recordId);

  const mappedArchivedPolicies = useMemo(() => {
    if (isLoading) {
      return [];
    }

    // add insuredId and jobId into row
    return archivedPolicies.map(p => ({ ...p, insuredId, jobId, recordId }));
  }, [archivedPolicies, isLoading]);

  if (isLoading) {
    return (
      <Flex
        justifyContent="center"
        position="relative"
      >
        <LoadingSpinner isInline />
      </Flex>
    );
  }

  return (
    <ArchivedModal
      data={mappedArchivedPolicies}
      data-cy={CypressIds.archivedPoliciesModal}
      duskId="archived-policies-modal"
      tableColumns={COLUMNS}
    />
  );
};

ArchivedPoliciesModal.propTypes = {
  insuredId: PropTypes.number.isRequired,
  recordId: PropTypes.number.isRequired,
  jobId: PropTypes.number.isRequired
};

export default ArchivedPoliciesModal;
